module.exports = __webpack_public_path__ + "img/12.ae44a50a.jpg";